import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SitemapGenerator component
 * 
 * This component can be used to dynamically generate a sitemap.xml file
 * It's particularly useful for sites with dynamic content like blogs
 * 
 * Note: For a production implementation, you would typically generate the sitemap
 * server-side or during the build process, but this component can be used
 * for client-side generation in certain scenarios.
 */
export interface SitemapURL {
  loc: string;
  lastmod?: string;
  changefreq?: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority?: number;
  images?: {
    loc: string;
    title?: string;
    caption?: string;
  }[];
}

interface SitemapGeneratorProps {
  baseUrl: string;
  urls: SitemapURL[];
}

const SitemapGenerator: React.FC<SitemapGeneratorProps> = () => {
  // The sitemap is pre-generated and served as a static file
  // This component only adds the link tag to help search engines discover it

  return (
    <Helmet>
      <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
    </Helmet>
  );
};

export default SitemapGenerator;

// Example usage:
/*
<SitemapGenerator 
  baseUrl="https://biodata360.in"
  urls={[
    { 
      loc: '/', 
      lastmod: '2024-05-15', 
      changefreq: 'weekly', 
      priority: 1.0,
      images: [
        { 
          loc: 'https://biodata360.in/lovable-uploads/7c02dd2b-f0b1-4472-972e-58a1e2ed7042.png',
          title: 'Biodata360 Logo'
        }
      ]
    },
    { 
      loc: '/blog', 
      lastmod: '2024-05-15', 
      changefreq: 'weekly', 
      priority: 0.8 
    },
    // Add more URLs as needed
  ]}
/>
*/